import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Translate, CaretDown } from "@phosphor-icons/react";
import { LANGUAGES } from "../i18n/i18n";

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative" data-testid="language-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-3 py-2 rounded-md border border-border hover:bg-secondary text-left"
        data-testid="language-toggle-btn"
      >
        <div className="flex items-center gap-2">
          <Translate size={14} className="text-muted-foreground"/>
          <div>
            <div className="eos-overline">{t("app.language")}</div>
            <div className="text-[13px] font-medium tracking-tight mt-0.5">{current.native}</div>
          </div>
        </div>
        <CaretDown size={14} weight="bold" className="text-muted-foreground"/>
      </button>
      {open && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-border rounded-md shadow-lg overflow-hidden z-20 max-h-72 overflow-y-auto" data-testid="language-menu">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => change(l.code)}
              className={`w-full text-left px-3 py-2 text-sm hover:bg-secondary flex items-center justify-between ${i18n.language === l.code ? "font-semibold text-[hsl(244_53%_20%)]" : ""}`}
              data-testid={`language-option-${l.code}`}
            >
              <span>{l.native}</span>
              <span className="text-[10px] text-muted-foreground uppercase">{l.code}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
